<p>common-warnings works!</p>
